import Vue from 'vue';
import Notify from "./index.vue";

const NotifyBox = Vue.extend(Notify);

Notify.install = function(options, type){
  
  options = Object.prototype.toString.call(options) === "[object Object]" ? options : {};

  console.log(options)
  let instance = new NotifyBox({
    data: options
  }).$mount();
  console.log(instance.$el)
  document.body.appendChild(instance.$el);

  Vue.nextTick(() => {
    instance.visible = true
  })
};

export default Notify;


// WEBPACK FOOTER //
// ./src/components/Notification/index.js